export const letterArr = [
   'a',
   'b',
   'c',
   'd',
   'e',
   'f',
   'g',
   'h',
   'i',
   'j',
   'k',
   'l',
   'm',
   'n',
   'o',
   'p',
   'q',
   'r',
   's',
   't',
   'u',
   'v',
   'w',
   'x',
   'y',
   'z',
];
export const symbolArr = [
   '!',
   '@',
   '#',
   '$',
   '%',
   '^',
   '&',
   '*',
   '(',
   ')',
   '[',
   ']',
   '{',
   '}',
   ':',
   ';',
   '/',
   '|',
   '<',
   '>',
   '=',
   '-',
   '_',
   '+',
   '`',
   '~',
];
export const fieldsArr = [
   { id: 1, name: 'isUppercase', labelText: 'Использовать заглавные буквы' },
   { id: 2, name: 'isLowercase', labelText: 'Использовать прописные буквы' },
   { id: 4, name: 'isSymbols', labelText: 'Использовать символы' },
   { id: 3, name: 'isNumbers', labelText: 'Использовать цифры' },
];
